<page-grid
  [gridConfig]="adxBookingToTramsInvoiceLinksGrid"
  (gridClickColumn)="handleIdClick($event)">
  <ng-template #actionItem let-item="item">
    <mat-slide-toggle 
      [(ngModel)]="item.isEligible" 
      (change)="onToggleIsEligible(item)" 
      [disabled]="isTogglePending"
      color="primary">
    </mat-slide-toggle>
  </ng-template>
</page-grid>